import React from 'react'

class LogoProduct extends React.Component {
    render() {
        return (

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
                <g fill="none" fill-rule="evenodd">
                    <path fill="#89D3E0" d="M347.128 198.38c-1.94-10.74-34.104-24.48-34.104-24.48-44.572-13.872-52.428-30.248-52.428-30.248 1.92-9.952-2.552-23.18-2.552-23.18-26.116-23.648-82.628-3.404-82.628-3.404-78.732 11.808-100.308 60.576-100.308 60.576C16.02 260.584 10.2 433.2 10 491.956c86.932-14.196 94.12-86.572 94.12-86.58.276-20.052 1.692-35.356 1.692-35.356 12.064-73.74 34.328-114.96 43.756-120.632 2.056-1.236 19.008 10.132 35.72 5.528 25.888-7.132 35.16-8.936 51.192-24.98 3.768-3.772 12.316-1.464 33-9.676 11.108-4.408 53.644-.864 56.356-.972 6.46-.264 7.712-2.652 7.712-2.652-16.764-1.02-35.684-5.368-46.692-8.228 20.252 3.832 51.784 1.66 54.768 1.784 3.508.144 6.944-3.832 5.504-11.812"/>
                    <path fill="#FEFEFE" d="M232.8 161.404L209.94 139l-3.94 4.024 22.856 22.404"/>
                    <path fill="#FEFEFE" d="M232.428 141.944L210.024 164.8 206 160.856 228.404 138"/>
                </g>
            </svg>

        );
    }
}

export default LogoProduct



// WEBPACK FOOTER //
// ../components/SVG/LogoProduct.jsx